import { Flex, Text, ThemeUIStyleObject } from "theme-ui";

type ErrorDescriptionProps = {
  sx?: ThemeUIStyleObject;
  children: React.ReactNode;
};

export const ErrorDescription: React.FC<ErrorDescriptionProps> = ({ children, sx }) => (
  <Flex
    variant="layout.errorDescription"
    sx={{
      ...sx
    }}
  >
    <Text sx={{ ml: 2, wordBreak: "break-all" }}>{children}</Text>
  </Flex>
);
